/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"
import DoughnutChart from "./doughnut_chart"
import StarBg from "../../../../vendor/javascript/star_bg"

function MasteryLevel({mastery_level, full_mastery}) {
  const quiz_level = [
    mastery_level.learning,
    mastery_level.mastering,
    mastery_level.mastery,
    mastery_level.undiscovered
  ]
  return (
    <div className="mastery-level-container">
      {!full_mastery &&
        <StarBg/>
      }
      {full_mastery &&
        <div className="stag-bg--gold">
          <StarBg/>
        </div>
      }
      <div className="title">
        {I18n.t("js.new_embedded_quiz.study_summary.mastery_level")}
      </div>
      {full_mastery &&
        <FaIcon name={"fa-star-circle"} />
      }
      {!full_mastery &&
        <div className="progress-donut-container">
          <div className="progress-donut">
            <DoughnutChart
              data_set={quiz_level}
              label={"quiz-mastery"}
            />
          </div>
          <FaIcon name={"fa-star-o"} />
        </div>
      }
    </div>
  )
}

export default MasteryLevel
